<template>
    <div
        :class="wrapperClass"
        :style="borderRadiusStyle"
    >
        <div
            :aria-label="cookedLabel"
            :aria-valuenow="value"
            :style="[barStyle, borderRadiusStyle]"
            :aria-valuemax="max"
            :aria-valuemin="min"
            :class="bgClass"
            class="text-nowrap"
            role="progressbar"
        />

        <slot />
    </div>
</template>

<script>
import tinycolor from "tinycolor2"

export default {
    props: {
        value: {
            type: Number,
            required: true,
        },

        max: {
            type: Number,
            default: 100,
        },

        min: {
            type: Number,
            default: 0,
        },

        smooth: {
            type: Boolean,
            default: true,
        },

        height: {
            type: Number,
            default: 4,
        },

        backgroundColor: {
            type: String,
            default: "white",
        },

        ignoreReadability: {
            type: Boolean,
            default: false,
        },

        ariaLabel: String,
    },

    data() {
        return {
            readabilityLimit: 2,
        }
    },

    computed: {
        primaryColor() {
            return this.$store.state.theme.customization.primaryColor
        },

        bgClass() {
            if (this.backgroundColor == "primary") return "bg-light"
            const bgPrimary = this.$css(this.$theme.bgPrimary)

            if (this.ignoreReadability) return bgPrimary

            return tinycolor.readability(this.bgColor, this.primaryColor) >
                this.readabilityLimit
                ? bgPrimary
                : "bg-info"
        },

        bgColor() {
            switch (this.backgroundColor) {
                case "white":
                    return "#ffffff"
                case "dark":
                    return "#606060"
                case "dark-blue":
                    return "#1b2026"
                case "gray":
                    return "#808080"
                case "primary":
                    return this.primaryColor
                default:
                    throw new Error(
                        `Background color ${this.backgroundColor} is not implemented for progress bar`
                    )
            }
        },

        percent() {
            return (100 * this.value) / (this.max - this.min)
        },

        barStyle() {
            return {
                maxHeight: `${this.height}px`,
                minHeight: `${this.height}px`,
                width: `${this.percent}%`,
                transition: this.smooth ? "width 0.5s ease" : "",
            }
        },

        wrapperClass() {
            return this.backgroundColor == "white"
                ? "bg-gray-light"
                : "bg--white--20"
        },

        borderRadiusStyle() {
            return {
                borderRadius: `${this.height}px`,
                maxHeight: `${this.height}px`,
                minHeight: `${this.height}px`,
            }
        },

        cookedLabel() {
            return this.ariaLabel ?? this.$t("common.progress")
        },
    },
}
</script>
